<div style="position: fixed; top:0; z-index: 1000; left:0; height:100%; width:100%; background: #222c;">
</div>


<ion-card
  style="z-index:1001; position: fixed; top: 100px; left: 5vw; height: 50vh; width: 90vw; margin: 0px; overflow: auto;">
  <ion-card class="margin0 padding5 font1_5 primaryBg">
    {{type}} Rules
    <ion-icon color='danger' name="close-circle" style="position: fixed; right:20px; top:10px; z-index: 99;"
      class='floatingCloseAttachment cursorpoint' (click)='closePopup.emit()'></ion-icon>
  </ion-card>

  <div>You can add any type of rule for the {{type}}s participating in this election. Just by selecting the Variable,
    Operator, Value</div>

  <app-a-select [label]="'Variable'" [type]="'Object'" (variableChange)="onSelectVariable($event)" [value]="'value'"
    [(variable)]="variable" [objectList]="variableList"></app-a-select>
  <app-a-select [label]="'Operator'" [type]="'Object'" [(variable)]="operator"
    [objectList]="operatorList"></app-a-select>
  <app-a-select [label]="'Value'" [type]="valueType" [(variable)]="value" [objectList]="valueList"></app-a-select>

  <ion-row>
    <ion-col>
      <ion-button (click)="onClickRemove()" size="small" fill="outline" expand="block" color="danger">
        Remove Rule
      </ion-button>
    </ion-col>
    <ion-col>
      <ion-button (click)="onClickSave()" size="small" expand="block" color="success">
        Save Rule
      </ion-button>
    </ion-col>
  </ion-row>

</ion-card>